import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
// import { InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import PhonesDetailsSectionInfo from './sections/PhonesDetailsSectionInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			{/* <InlineTitle text="DETAILS_INFO_SECTION" /> */}
			<PhonesDetailsSectionInfo {...props} />
		</>
	)
};

export default dialogSettings;
